// extracted by mini-css-extract-plugin
export default {"media":"media_media__56YHi","news":"media_news__-dYvJ","video":"media_video__8i3Y5","para":"media_para__72L7E"};